// ---------------------------------------------------------------------------
// Form control tokens for the fiche's inputs — the session filters and the
// three lead-capture modals (enrollment, download, share).
//
// These were four near-identical class strings that had drifted apart: three
// different heights, two label sizes, and a focus ring on some fields but not
// others. One definition keeps them identical, and puts every control on a
// 44px target with text above the 12px floor.
// ---------------------------------------------------------------------------

/** 44px tall — the minimum comfortable touch target. */
export const CONTROL_HEIGHT = "h-11";

/* #ABABAB rather than the old #EFEFEF: a border at 1.06:1 against the white
   card was invisible, which left the fields with no perceivable boundary. */
const CONTROL_BASE =
  "w-full rounded-lg border border-[#ABABAB] bg-white text-[13px] font-normal text-[#1B365E] placeholder:text-[#767676] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE] transition-colors";

export const INPUT_CLASS = `${CONTROL_BASE} ${CONTROL_HEIGHT} px-3`;

/** Same control, but height comes from `rows` rather than a fixed value. */
export const TEXTAREA_CLASS = `${CONTROL_BASE} px-3 py-2.5 resize-none`;

/** Uppercase field label. Small by design, so it carries weight and tracking. */
export const LABEL_CLASS =
  "text-[#1B365E] text-[11px] font-bold uppercase tracking-[0.6px]";

/** Border shown on a field that failed validation. */
export const INPUT_ERROR_CLASS = "border-red-400 focus:border-red-400 focus:ring-red-400";
